module.exports = __webpack_public_path__ + "static/media/pattern.d81d6cd4.png";